module.exports = __webpack_public_path__ + "static/media/electronic-lock.51a5d585.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/electronic-lock.png
// module id = 1192
// module chunks = 0